<div class="dialog-header">
  <div>
    <h2 mat-dialog-title>{{ data.titulo }}</h2>
    @if (data.subtitulo) {
      <p>{{ data.subtitulo }}</p>
    }
  </div>
  <button mat-icon-button type="button" aria-label="Fechar" (click)="fechar()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  @if (!data.logs.length) {
    <div class="empty-state">
      <mat-icon>assignment</mat-icon>
      <strong>Nenhum log encontrado</strong>
    </div>
  } @else {
    <div class="logs-table">
      <div class="logs-table__header">
        <span>Inclusão</span>
        <span>Data</span>
        <span>Identificador</span>
        <span>Código/Status</span>
        <span>Mensagem</span>
        <span>URL</span>
      </div>

      @for (log of data.logs; track log.id) {
        <div class="logs-table__row">
          <span>{{ log.dataHoraInclusao | date: 'dd/MM/yyyy HH:mm' }}</span>
          <span>{{ log.data | date: 'dd/MM/yyyy' }}</span>
          <span [matTooltip]="log.idLoteScanntech || log.identificador || ''">
            {{ log.idLoteScanntech || log.identificador || '-' }}
          </span>
          <span>{{ log.codigo || log.status || '-' }}</span>
          <span class="message-cell" [matTooltip]="log.mensagem || ''">{{ log.mensagem || '-' }}</span>
          <span class="url-cell" [matTooltip]="log.url || ''">{{ log.url || '-' }}</span>
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="button" class="btn-primary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
